import { render, staticRenderFns } from "./PromoAsssets.vue?vue&type=template&id=bc8bf0c8&"
import script from "./PromoAsssets.vue?vue&type=script&lang=js&"
export * from "./PromoAsssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports